<div id="complete-profile-screen">
      <app-complete-profile-confirmation></app-complete-profile-confirmation>
</div>